import styled, {css} from 'styled-components';

export const Wrapper = styled.div`
    width: 50%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(3, minmax(1rem, 1fr));
    gap: 1rem;
    padding: 20px 25px;
    background-color: #1e1e1e;
    place-items: center;
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const Item = styled.div<{$active: boolean; $focused: boolean; $backgroundImage?: string}>`
    box-sizing: border-box;
    background-color: ${({$active}) => ($active ? '#3AB8FF' : '#000')};
    background-image: ${({$backgroundImage}) => ($backgroundImage ? `url(${$backgroundImage})` : 'none')};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border: 2px solid ${({$focused}) => ($focused ? '#3AB8FF' : 'rgba(0, 0, 0, 0.3)')};
    color: white;
    font-weight: bold;
    border-radius: 20px;
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-image: ${({$backgroundImage}) => ($backgroundImage ? `url(${$backgroundImage})` : 'none')};
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: inherit;
        z-index: 0;
        transform: scale(1);
        transform-origin: center;
        transition:
            transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1),
            background-color 0.3s;
        pointer-events: none;
    }

    &::after {
        content: '';
        position: absolute;
        inset: -2px;
        background-color: rgba(0, 0, 0, 0);
        border-radius: inherit;
        z-index: 0;
        pointer-events: none;
        transition: background-color 0.3s;
    }

    ${({$focused}) =>
        $focused &&
        css`
            &::before {
                transform: scale(1.08);
            }
        `}

    span {
        position: relative;
        z-index: 1;
    }

    &:hover {
        background-color: ${({$active}) => ($active ? '#34a3e0' : '#111')};
    }
`;

export const Icon = styled.div`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 1.5rem;
    height: 1.5rem;
    border-top: 2px solid #3ab8ff;
    border-bottom: 2px solid #3ab8ff;

    &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: -4px;
        width: 16px;
        height: 2px;
        background-color: #3ab8ff;
        transform: translateY(-50%);
    }
`;

export const PageWrapper = styled.div`
    width: 50%;
    height: 100%;
    padding: 20px 25px;
    overflow-y: auto;
    font-size: x-large;
`;

export const BackButton = styled.button<{$focused?: boolean}>`
    background: none;
    border: 2px solid #3ab8ff;
    color: white;
    font-weight: bold;
    border-radius: 6px;
    padding: 8px 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 20px;

    &:hover {
        background-color: #3ab8ff;
        color: #000;
    }

    ${(props) =>
        props.$focused &&
        `
        background-color: #00bfff !important;
        color: #000 !important;
        box-shadow: 0 0 10px rgba(0, 191, 255, 0.5);
        transform: scale(1.05);
    `}
`;

export const TableHeader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding: 12px 8px;
    background-color: #2a2a2a;
    color: white;
    font-weight: bold;
    border-radius: 6px;
`;

export const StyledNameDisplay = styled.span`
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const List = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 8px;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 8px;
    border-bottom: 1px solid #444;
    color: white;
`;

export const SelectButton = styled.button<{$selected: boolean; $focused: boolean}>`
    background-color: ${({$selected}) => ($selected ? '#3ab8ff' : 'transparent')};
    border: 2px solid #3ab8ff;
    border-radius: 20px;
    padding: 6px 14px;
    font-weight: bold;
    cursor: pointer;
    color: ${({$selected}) => ($selected ? '#000' : '#fff')};
    box-shadow: ${({$focused}) => ($focused ? '0 0 10px rgba(0, 191, 255, 1)' : 'none')};

    &:hover {
        background-color: ${({$selected}) => ($selected ? '#00bfff' : '#00bfff')};
    }
`;

export const CallButton = styled.button<{$disabled: boolean; $focused: boolean}>`
    background-color: ${({$disabled, $focused}) => ($disabled ? '#333' : $focused ? '#00bfff' : 'transparent')};
    border: 2px solid #3ab8ff;
    border-radius: 20px;
    padding: 6px 14px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
    color: ${({$disabled}) => ($disabled ? '#aaa' : '#fff')};

    ${({$disabled}) =>
        $disabled &&
        `
        pointer-events: none;
        border: 2px solid #444;
    `}
    &:hover {
        border: 2px solid #00bfff;
    }

    ${({$focused, $disabled}) =>
        $focused &&
        `
        background-color: #00bfff !important;
        color: #000 !important;
        box-shadow: 0 0 10px rgba(0, 191, 255, 0.5);
        transform: scale(1.05);
    `}
`;
